const textSizeMap = {
    s: "heading-xxxs",
    m: "heading-xxs",
    l: "heading-xs",
    xl: "heading-s",
};
const spinnerSizeMap = {
    s: "20px",
    m: "28px",
    l: "28px",
    xl: "28px",
};

export { spinnerSizeMap, textSizeMap };
//# sourceMappingURL=Button.consts.js.map
